import React, { useEffect, useState } from "react";
import { message, Table, Modal, Input } from "antd";
import { get, patch } from "../../api/axios";
import { axiosApi1 as multipartAxios } from "../../api/axios"; // named export for file upload
import { Pagination } from "antd";
import SearchBar from "../../utils/SearchBar";
import { useRef } from "react";
import { baseUrl } from "../../api/axios";

const Payouts = () => {
  const getBaseFileUrl = () => {
    return baseUrl.replace("/api/admin/", "/");
  };

  const fileInputRef = useRef(null);

  const columns = [
    // 1. بيانات الحجز
    {
      title: (
        <>
          بيانات الحجز
          <br />
          رقم الحجز
          <br />
          اسم الوحدة
          <br />
          كود الوحدة
          <br />
        </>
      ),
      render: ({ invoice_id, property }) => (
        <>
          {invoice_id || "-"} <br />
          {property?.name || "-"} <br />
          {property?.id ? `U${property?.id}` : "-"} <br />
        </>
      ),
    },
    // 2. بيانات الضيف
    {
      title: (
        <>
          بيانات الضيف
          <br />
          اسم الضيف
          <br />
          البريد الإلكتروني
          <br />
          الجوال
          <br />
          رقم الضيف
          <br />
        </>
      ),
      dataIndex: "user",
      render: (user) => {
        const { name, phone, email, id } = user || {};
        return (
          <span>
            {name || "-"}
            <br />
            {email || "-"}
            <br />
            {phone || "-"}
            <br />
            {id ? `G${id}` : "-"} <br />
          </span>
        );
      },
    },
    // 3. بيانات المضيف
    {
      title: (
        <>
          بيانات المضيف
          <br />
          اسم المضيف
          <br />
          الجوال
          <br />
          البريد الإلكتروني
          <br />
          رقم المضيف
          <br />
        </>
      ),
      dataIndex: "owner",
      render: (owner) => {
        const { name, phone, email, id } = owner || {};
        return (
          <span>
            {name || "-"}
            <br />
            {phone || "-"}
            <br />
            {email || "-"}
            <br />
            {id ? `H${id}` : "-"} <br />
          </span>
        );
      },
    },
    // 4. البيانات البنكية للمضيف
    {
      title: (
        <>
          البيانات البنكية
          <br />
          طريقة استلام المبلغ
          <br />
          اسم صاحب الحساب
          <br />
          البنك <br />
          رقم الايبان
          <br />
        </>
      ),
      render: ({ payment_method, owner_name, bank }) => (
        <span>
          {payment_method?.label || "غير متوفر"}
          <br />
          {bank?.bank_account_owner || "غير متوفر"}
          <br />
          {payment_method?.type === "bank_account" ? (
            <>
              {bank?.name_ar} <br />
              {bank?.iban ? `SA${bank.iban}` : "غير متوفر"}
            </>
          ) : (
            <> - </>
          )}
        </span>
      ),
    },
    // 5. بيانات الحوالة (الرقم، التواريخ، المبلغ، الحالة، كود المنصة)
    {
      title: (
        <>
          بيانات الحوالة
          <br />
          رقم الحوالة
          <br />
          تاريخ انشاء الحوالة
          <br />
          انشاء الحوالة بواسطة
          <br />
          مبلغ الحوالة
          <br />
          تاريخ تنفيذ الحوالة
          <br />
          تنفيذ الحوالة بواسطة
          <br />
          حالة الحوالة
          <br />
        </>
      ),
      render: ({
        amount,
        created_at,
        id,
        created_by,
        paid_at,
        payout_status,
        paid_by,
        prices,
      }) => {
        return (
          <span>
            {id ? `TRN${id}` : "غير متوفر"}
            <br />
            {created_at || "-"}
            <br />
            {created_by || "-"}
            <br />
            {amount || "-"}
            <br />
            {paid_at || "-"}
            <br />
            {paid_by || "-"}
            <br />
            {payout_status || "غير متوفر"}
          </span>
        );
      },
    },
    // 6. البيانات المالية للتحويل (من invoice_transfers)
    {
      title: (
        <>
          البيانات المالية للتحويل
          <br />
          مبلغ الحوالة
          <br />
          العملة المنفذة
          <br />
          مبلغ التحويل
          <br />
          (رسوم التحويل)
          <br />
          (ضريبة رسوم التحويل)
          <br />
          (رسوم التحويل شامل الضريبة)
          <br />
          مبلغ كود المنصة
          <br />
        </>
      ),
      render: (record) => {
        const transfer = Array.isArray(record.invoice_transfers)
          ? record.invoice_transfers[0]
          : record.invoice_transfers;

        const isMakanCoupon =
          record.coupon?.coupon_type === "MAKAN" &&
          record.coupon?.coupon_amount != null;

        return (
          <span>
            {formatNumber(transfer?.transfer_amount) || "-"}
            <br />
            {transfer?.executed_currency || "-"}
            <br />
            {formatNumber(transfer?.converted_amount) || "-"}
            <br />
            {formatNumber(transfer?.transfer_fees) || "-"}
            <br />
            {formatNumber(transfer?.transfer_tax) || "-"}
            <br />
            {formatNumber(transfer?.total_transfer_fees) || "-"}
            <br />
            {isMakanCoupon ? record.coupon.coupon_amount : "-"}
          </span>
        );
      },
    },
    // 7. بيانات الحساب (المصدر والمستفيد)
    {
      title: (
        <>
          بيانات الحساب
          <br />
          رقم الحساب المصدر
          <br />
          البنك المصدر
          <br />
          العملة المصدرة
          <br />
          اسم المستفيد
          <br />
          رقم حساب المستفيد
          <br />
          بنك المستفيد
          <br />
          العملة المستلمة
        </>
      ),
      render: (record) => {
        const transfer = Array.isArray(record.invoice_transfers)
          ? record.invoice_transfers[0]
          : record.invoice_transfers;

        return (
          <span>
            {transfer?.source_account_number || "-"}
            <br />
            {transfer?.source_bank || "-"}
            <br />
            {transfer?.source_currency || "-"}
            <br />
            {transfer?.beneficiary_name || "-"}
            <br />
            {transfer?.beneficiary_account_number || "-"}
            <br />
            {transfer?.beneficiary_bank || "-"}
            <br />
            {transfer?.beneficiary_currency || "-"}
          </span>
        );
      },
    },
    // 8. بيانات عملية التحويل (مرجع، تاريخ، نوع، وصف، مرفق، ملاحظة)
    {
      title: (
        <>
          بيانات عملية التحويل
          <br />
          الرقم المرجعي
          <br />
          تاريخ العملية
          <br />
          نوع العملية
          <br />
          السرد (حوالة)
          <br />
          مرفق الحوالة
          <br />
          ملاحظة
          <br />
          كود المنصة
          <br />
        </>
      ),
      render: (record) => {
        const transfer = Array.isArray(record.invoice_transfers)
          ? record.invoice_transfers[0]
          : record.invoice_transfers;

        const isMakanCoupon =
          record.coupon?.coupon_type === "MAKAN" &&
          record.coupon?.coupon_code != null;

        return (
          <span>
            {transfer?.reference_number || "-"}
            <br />
            {transfer?.operation_date || "-"}

            <br />
            {transfer?.operation_type || "-"}
            <br />
            {transfer?.description || "-"}
            <br />
            {transfer?.attachment ? (
              <a
                href={
                  transfer.attachment?.startsWith("http")
                    ? transfer.attachment
                    : `${getBaseFileUrl()}storage/${transfer.attachment}`
                }
                target="_blank"
                rel="noreferrer"
              >
                عرض المرفق
              </a>
            ) : (
              "-"
            )}
            <br />
            {transfer?.notes || "-"}
            <br />
            {isMakanCoupon ? record.coupon.coupon_code : "-"}
          </span>
        );
      },
    },
    // 9. إدارة عملية التحويل (أزرار)
    {
      title: (
        <>
          إدارة عملية التحويل
          <br />
          تنفيذ حوالة
          <br />
          اثبات عملية تحويل
        </>
      ),
      render: (_, record) => {
        const { payout_status, id } = record;
        return (
          <>
            <button
              onClick={() => handleStatus(id)}
              disabled={payout_status === "منفذة" || loadingStates[id]}
              className={`btn ${
                payout_status === "منفذة" ? "btn-primary" : "btn-warning"
              } py-0`}
            >
              {loadingStates[id]
                ? "Loading..."
                : payout_status === "منفذة"
                  ? "منفذة"
                  : "قيد التنفيذ"}
            </button>
            <br />
            <br />
       <button
  className="btn btn-primary py-0"
  onClick={() => {
    setSelectedPayout(record);
    setOpenTransferModal(true);

    const existingTransfer = Array.isArray(record.invoice_transfers)
      ? record.invoice_transfers[0]
      : record.invoice_transfers;

    const defaultAmount = extractNumberFromPrice(record.amount);

    const generatedDescription = `B${record.invoice_id}-U${
      record.property?.id ?? "0"
    }-G${record.user?.id ?? "0"}-H${record.owner?.id ?? "0"}-T${record.id ?? "0"}`;

    setTransferForm({
      payout_id: record.id,

      transfer_amount:
        existingTransfer?.transfer_amount ?? defaultAmount,

      executed_currency:
        existingTransfer?.executed_currency ?? "SAR",

      converted_amount:
        existingTransfer?.converted_amount ?? "",

      transfer_fees:
        existingTransfer?.transfer_fees ?? "",

      transfer_tax:
        existingTransfer?.transfer_tax ?? "",

      total_transfer_fees:
        existingTransfer?.total_transfer_fees ??
        (
          (parseFloat(existingTransfer?.transfer_fees) || 0) +
          (parseFloat(existingTransfer?.transfer_tax) || 0)
        ).toString(),

      source_account_number:
        existingTransfer?.source_account_number ?? "3970025739940",

      source_bank:
        existingTransfer?.source_bank ?? "بنك الرياض",

      source_currency:
        existingTransfer?.source_currency ?? "SAR",

      beneficiary_name:
        existingTransfer?.beneficiary_name ?? "",

      beneficiary_account_number:
        existingTransfer?.beneficiary_account_number ?? "",

      beneficiary_bank:
        existingTransfer?.beneficiary_bank ?? "",

      beneficiary_currency:
        existingTransfer?.beneficiary_currency ?? "SAR",

      reference_number:
        existingTransfer?.reference_number ?? "",

      operation_date:
        existingTransfer?.operation_date ?? "",

      operation_type:
        existingTransfer?.operation_type ?? "تحويل محلي",

      description:
        existingTransfer?.description &&
        existingTransfer.description.trim() !== ""
          ? existingTransfer.description
          : generatedDescription,

      notes:
        existingTransfer?.notes ?? "",

      attachment: null,
    });

    setAttachmentFile(null);
  }}
>
  إثبات تحويل
</button>
          </>
        );
      },
    },
  ];

  // ------------------------ State ------------------------
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);
  const [total, setTotal] = useState(1);
  const [loadingStates, setLoadingStates] = useState({});

  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [confirmTransferLoading, setConfirmTransferLoading] = useState(false);
  const [selectedPayout, setSelectedPayout] = useState(null);
  const [attachmentFile, setAttachmentFile] = useState(null);

  const [transferForm, setTransferForm] = useState({
    payout_id: "",
    transfer_amount: "",
    executed_currency: "",
    converted_amount: "",
    transfer_fees: "",
    transfer_tax: "",
    total_transfer_fees: "",
    source_account_number: "",
    source_bank: "",
    source_currency: "",
    beneficiary_name: "",
    beneficiary_account_number: "",
    beneficiary_bank: "",
    beneficiary_currency: "",
    reference_number: "",
    operation_date: "",
    operation_type: "",
    description: "",
    notes: "",
    attachment: null,
  });

  // Helper: extract number from "45 SAR" -> "45"
  const extractNumberFromPrice = (priceStr) => {
    if (!priceStr) return "";
    const match = priceStr.match(/(\d+(?:\.\d+)?)/);
    return match ? match[1] : "";
  };

  const handleTransferChange = (e) => {
    const { name, value } = e.target;

    setTransferForm((prev) => {
      const updated = { ...prev, [name]: value };

      const fees =
        parseFloat(name === "transfer_fees" ? value : updated.transfer_fees) ||
        0;

      const tax =
        parseFloat(name === "transfer_tax" ? value : updated.transfer_tax) || 0;

      updated.total_transfer_fees = (fees + tax).toString();

      return updated;
    });
  };

  const handleAttachmentChange = (e) => {
    const file = e.target.files[0];
    setAttachmentFile(file);
    setTransferForm((prev) => ({ ...prev, attachment: file }));
  };

  // Submit transfer proof using multipart axios instance
  const handleTransferSubmit = async () => {
    if (!transferForm.payout_id) {
      message.error("بيانات الحجز غير مكتملة");
      return;
    }

    setConfirmTransferLoading(true);
    try {
      const formData = new FormData();
  Object.keys(transferForm).forEach((key) => {
  if (key !== "attachment") {
    formData.append(key, transferForm[key] ?? "");
  }
});
      if (attachmentFile) {
        formData.append("attachment", attachmentFile);
      }

      // Use multipartAxios (which has correct headers for file upload)
      const response = await multipartAxios.post(
        "invoice-transfers",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.data?.success !== false) {
        message.success("تم حفظ إثبات التحويل بنجاح");
        setOpenTransferModal(false);
        // Refresh table data
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
        const res = await get(`payouts?search=${searchQuery}`);
        setData(res?.data.data || []);
        setTotal(res?.data.meta?.last_page || 1);
        // Reset form
        // setTransferForm({
        //   payout_id: "",
        //   transfer_amount: "",
        //   executed_currency: "",
        //   converted_amount: "",
        //   transfer_fees: "",
        //   transfer_tax: "",
        //   total_transfer_fees: "",
        //   source_account_number: "",
        //   source_bank: "",
        //   source_currency: "",
        //   beneficiary_name: "",
        //   beneficiary_account_number: "",
        //   beneficiary_bank: "",
        //   beneficiary_currency: "",
        //   reference_number: "",
        //   operation_date: "",
        //   operation_type: "",
        //   description: "",
        //   notes: "",
        //   attachment: null,
        // });
        setAttachmentFile(null);
      } else {
        message.error(response.data?.message || "حدث خطأ أثناء حفظ البيانات");
      }
    } catch (error) {
      console.error(error);
      message.error("فشل في إرسال البيانات، يرجى المحاولة مرة أخرى");
    } finally {
      setConfirmTransferLoading(false);
    }
  };

  const handleStatus = (id) => {
    setLoadingStates((prev) => ({ ...prev, [id]: true }));
    patch(`payouts/${id}`, {}, {})
      .then(() => {
        message.success("تم تغيير الحالة بنجاح");
        return get(`payouts?search=${searchQuery}`);
      })
      .then((res) => {
        setData(res?.data.data || []);
        setTotal(res?.data.meta?.last_page || 1);
      })
      .catch(() => message.error("حدث خطأ أثناء تغيير الحالة"))
      .finally(() => setLoadingStates((prev) => ({ ...prev, [id]: false })));
  };

  useEffect(() => {
    setLoading(true);
    get(`payouts?search=${searchQuery}`)
      .then((res) => {
        setData(res?.data.data || []);
        setTotal(res?.data.meta?.last_page || 1);
      })
      .finally(() => setLoading(false));
  }, [debouncedValue]);

  const handlePagination = (pageNumber) => {
    setLoading(true);
    get(`payouts?page=${pageNumber}&search=${searchQuery}`)
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const formatNumber = (val) => {
    if (val === null || val === undefined || val === "") return val;
    const num = parseFloat(val);
    return Number.isInteger(num) ? num : num;
  };

  useEffect(() => {
    const fees = parseFloat(transferForm.transfer_fees) || 0;
    const tax = parseFloat(transferForm.transfer_tax) || 0;
    const total = fees + tax;

    setTransferForm((prev) => ({
      ...prev,
      total_transfer_fees: total ? total.toString() : "",
    }));
  }, [transferForm.transfer_fees, transferForm.transfer_tax]);
  // ------------------------ Render ------------------------
  return (
    <div>
      <div className="row">
        <SearchBar
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          debouncedValue={debouncedValue}
          setDebouncedValue={setDebouncedValue}
        />
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              bordered
              scroll={{ y: "65vh", x: 1750 }}
              columns={columns}
              dataSource={data}
              rowKey="id"
              size="middle"
            />
            <Pagination
              defaultCurrent={1}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />

            {/* Transfer Proof Modal */}
            <Modal
              title={
                <div style={{ textAlign: "center", fontWeight: 600 }}>
                  نموذج إثبات عملية تحويل
                </div>
              }
              centered
              open={openTransferModal}
              onOk={handleTransferSubmit}
              confirmLoading={confirmTransferLoading}
              onCancel={() => {
                setOpenTransferModal(false);
                setAttachmentFile(null);

                if (fileInputRef.current) {
                  fileInputRef.current.value = null;
                }
              }}
              okText="حفظ"
              cancelText="إغلاق"
              width={900}
              maskClosable={false}
              destroyOnClose
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: "20px",
                }}
              >
                {/* العمود الأول: البيانات المالية للتحويل */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <label>مبلغ الحوالة</label>
                  <Input
                    name="transfer_amount"
                    value={transferForm.transfer_amount}
                    onChange={handleTransferChange}
                    readOnly
                  />

                  <label>العملة المنفذة</label>
                  <Input
                    name="executed_currency"
                    value={transferForm.executed_currency}
                    onChange={handleTransferChange}
                  />

                  <label>مبلغ التحويل</label>
                  <Input
                    name="converted_amount"
                    value={transferForm.converted_amount}
                    onChange={handleTransferChange}
                  />

                  <label>(رسوم التحويل)</label>
                  <Input
                    name="transfer_fees"
                    value={transferForm.transfer_fees}
                    onChange={handleTransferChange}
                  />

                  <label>(ضريبة رسوم التحويل)</label>
                  <Input
                    name="transfer_tax"
                    value={transferForm.transfer_tax}
                    onChange={handleTransferChange}
                  />

                  <label>(رسوم التحويل شامل الضريبة)</label>
                  <Input
                    name="total_transfer_fees"
                    value={transferForm.total_transfer_fees}
                    onChange={handleTransferChange}
                  />
                </div>

                {/* العمود الثاني: بيانات الحساب (المصدر والمستفيد) */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <label>رقم الحساب المصدر</label>
                  <Input
                    name="source_account_number"
                    value={transferForm.source_account_number}
                    onChange={handleTransferChange}
                  />

                  <label>البنك المصدر</label>
                  <Input
                    name="source_bank"
                    value={transferForm.source_bank}
                    onChange={handleTransferChange}
                  />

                  <label>العملة المصدرة</label>
                  <Input
                    name="source_currency"
                    value={transferForm.source_currency}
                    onChange={handleTransferChange}
                  />

                  <label>اسم المستفيد</label>
                  <Input
                    name="beneficiary_name"
                    value={transferForm.beneficiary_name}
                    onChange={handleTransferChange}
                  />

                  <label>رقم حساب المستفيد</label>
                  <Input
                    name="beneficiary_account_number"
                    value={transferForm.beneficiary_account_number}
                    onChange={handleTransferChange}
                  />

                  <label>بنك المستفيد</label>
                  <Input
                    name="beneficiary_bank"
                    value={transferForm.beneficiary_bank}
                    onChange={handleTransferChange}
                  />

                  <label>العملة المستلمة</label>
                  <Input
                    name="beneficiary_currency"
                    value={transferForm.beneficiary_currency}
                    onChange={handleTransferChange}
                  />
                </div>

                {/* العمود الثالث: بيانات عملية التحويل */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <label>الرقم المرجعي</label>
                  <Input
                    name="reference_number"
                    value={transferForm.reference_number}
                    onChange={handleTransferChange}
                  />

                  <label>تاريخ العملية</label>
                  <Input
                    type="date"
                    name="operation_date"
                    value={transferForm.operation_date}
                    onChange={handleTransferChange}
                  />

                  <label>نوع العملية</label>
                  <Input
                    name="operation_type"
                    value={transferForm.operation_type}
                    onChange={handleTransferChange}
                  />

                  <label>السرد (حوالة)</label>
                  <Input
                    name="description"
                    value={transferForm.description}
                    onChange={handleTransferChange}
                  />

                  <label>مرفق الحوالة (ملف)</label>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleAttachmentChange}
                    />

                    {selectedPayout &&
                      (Array.isArray(selectedPayout.invoice_transfers)
                        ? selectedPayout.invoice_transfers[0]?.attachment
                        : selectedPayout.invoice_transfers?.attachment) && (
                        <a
                          href={
                            (Array.isArray(selectedPayout.invoice_transfers)
                              ? selectedPayout.invoice_transfers[0]?.attachment
                              : selectedPayout.invoice_transfers?.attachment
                            )?.startsWith("http")
                              ? Array.isArray(selectedPayout.invoice_transfers)
                                ? selectedPayout.invoice_transfers[0]
                                    ?.attachment
                                : selectedPayout.invoice_transfers?.attachment
                              : `${getBaseFileUrl()}storage/${
                                  Array.isArray(
                                    selectedPayout.invoice_transfers,
                                  )
                                    ? selectedPayout.invoice_transfers[0]
                                        ?.attachment
                                    : selectedPayout.invoice_transfers
                                        ?.attachment
                                }`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          عرض
                        </a>
                      )}
                  </div>

                  <label>ملاحظة</label>
                  <Input.TextArea
                    name="notes"
                    value={transferForm.notes}
                    onChange={handleTransferChange}
                    rows={2}
                  />
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payouts;
